<nav class="sidebar cursor-pointer" id="nav" style="z-index: 850;" [class.open]="open">

  <button mat-mini-fab class="button-open-menu" [class.open]="open" (click)="toogleMenu()" [matTooltip]="toolTipMessage"
    matTooltipPosition="right" matTooltipShowDelay="500" #tooltip="matTooltip">
    <fa-icon [icon]="['fal', open ? 'chevron-left' : 'chevron-right']" [fixedWidth]="false" class="font-10"></fa-icon>
  </button>


  <div class="w-100" style="position: relative;">
    <ul class="p-0 remove-style-list">
      <li *appShowHavePermission="'home'" class="item-sidebar d-flex align-item-center" id="item-menu-home"
        [routerLink]="['/home']" routerLinkActive="active">
        <div class="icon-sidebar" matTooltip="{{'common-page.sidebar.home' |
        translate}}" [matTooltipDisabled]="open" matTooltipPosition="right" #tooltip="matTooltip">
          <fa-icon [icon]="['fal','house']" class="font-16" [fixedWidth]="true"></fa-icon>
        </div>
        <p class="m-0 font-14 text-sidebar p-r-38 margin-left-n-16" id="text-item-home">{{ 'common-page.sidebar.home' |
          translate }}</p>
      </li>

      <li *appShowHavePermission="'fees'" routerLinkActive="active" class="item-sidebar d-flex align-item-center"
        id="item-menu-fee" [routerLink]="['/fee']">
        <div class="icon-sidebar" matTooltip="{{'login-page.login-form.fee' |
        translate}}" [matTooltipDisabled]="open" matTooltipPosition="right" #tooltip="matTooltip">
          <fa-icon [icon]="['fal','file-waveform']" class="font-16" [fixedWidth]="true"></fa-icon>
        </div>

        <p class="m-0 font-14 text-sidebar p-r-38 margin-left-n-16" id="text-item-fee">{{ 'login-page.login-form.fee' |
          translate }}</p>

      </li>

      <li *appShowHavePermission="'help'" class="item-sidebar d-flex align-item-center" id="item-menu-help"
        (click)="changeMenus('help')" [class.active]="router.isActive('help', false)">
        <div class="icon-sidebar">
          <fa-icon [icon]="['fal','circle-question']" class="font-16" [fixedWidth]="true"></fa-icon>
        </div>

        <p class="m-0 font-14 text-sidebar p-r-38 margin-left-n-16" id="text-item-help">{{ 'common-page.sidebar.help' |
          translate }}</p>
        <div class="sub-menu">
          @if( !menuHelp ){
          <fa-icon [icon]="['fal','angle-down']" class="font-16 text-sidebar" [fixedWidth]="true"></fa-icon>
          }@else {
          <fa-icon [icon]="['fal','angle-up']" class="font-16 text-sidebar" [fixedWidth]="true"></fa-icon>
          }
        </div>

        <ul class="ml-menu">
          <li class="d-flex flex-row justify-center" (click)="openHelp()">
            <a class="mat-body-1 m-l-20 m-r-20 m-t-11 m-b-11">
              {{ 'help-modal.help.title' | translate }}
            </a>
          </li>

          <li class="d-flex flex-row justify-center sub-menu-link" [routerLink]="['/help/user-manual']"
            routerLinkActive="active">
            <a class="mat-body-1 m-l-20 m-r-20 m-t-11 m-b-11">
              {{ 'common-page.sidebar.user-manual'| translate }}
            </a>
          </li>
        </ul>
      </li>

      @if( menuHelp ){
      <li class="d-flex align-item-center justify-start item-menu-need-help" id="item-menu-need-help"
        (click)="openHelp()">
        <p class="m-0 font-14 text-sidebar m-l-68 color-text">
          {{ 'help-modal.help.title' | translate }}
        </p>
      </li>
      <li class="d-flex align-item-center justify-start item-menu-need-help" id="item-menu-user-manual"
        [routerLink]="['/help/user-manual']" routerLinkActive="active">

        <p class="m-0 font-14 text-sidebar m-l-68 color-text">
          {{ 'common-page.navbar-user-menu.user-manual' | translate }}
        </p>
      </li>
      }


      <li *appShowHavePermission="'userManagement'" class="item-sidebar d-flex align-item-center" id="item-menu-configuration"
        (click)="changeMenus('configuration')" [class.active]="router.isActive('configuration', false)">
        <div class="icon-sidebar">
          <fa-icon [icon]="['fal','gear']" class="font-16" [fixedWidth]="true"></fa-icon>
        </div>

        <p class="m-0 font-14 text-sidebar p-r-38 margin-left-n-16" id="text-item-help">
          {{ 'common-page.sidebar.configuration' | translate }}
        </p>
        <div class="sub-menu">
          @if( !menuConfiguration ){
          <fa-icon [icon]="['fal','angle-down']" class="font-16 text-sidebar" [fixedWidth]="true"></fa-icon>
          }@else {
          <fa-icon [icon]="['fal','angle-up']" class="font-16 text-sidebar" [fixedWidth]="true"></fa-icon>
          }
        </div>

        <ul class="ml-menu">
          <li class="d-flex flex-row justify-center sub-menu-link" [routerLink]="['/configuration/profile']"
            routerLinkActive="active">
            <a class="mat-body-1 m-l-20 m-r-20 m-t-11 m-b-11">
              {{ 'common-page.sidebar.users'| translate }}
            </a>
          </li>
        </ul>
      </li>

      @if( menuConfiguration ){
      <li class="d-flex align-item-center justify-start item-menu-need-help" id="item-menu-configuration-profile"
        [routerLink]="['/configuration/profile']" routerLinkActive="active">

        <p class="m-0 font-14 text-sidebar m-l-68 color-text">
          {{ 'common-page.sidebar.users' | translate }}
        </p>
      </li>
      }

      <li class="item-sidebar d-flex align-item-center" id="item-menu-close-session" (click)="redirect('login')">
        <div class="icon-sidebar" matTooltip="{{'common-page.navbar-user-menu.logout' |
        translate}}" [matTooltipDisabled]="open" matTooltipPosition="right" #tooltip="matTooltip">
          <fa-icon [icon]="['fal','arrow-right-from-bracket']" class="font-16" [fixedWidth]="true"></fa-icon>
        </div>

        <p class="m-0 font-14 text-sidebar p-r-38 margin-left-n-16" id="text-item-close">{{
          'common-page.navbar-user-menu.logout' | translate }}</p>

      </li>
    </ul>

  </div>
</nav>